import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import HotRanking from './components/HotRanking';
import LatestUpdates from './components/LatestUpdates';
import CategoryGrid from './components/CategoryGrid';
import { featuredComic, faqList } from '@/mocks/comics';
import { Link } from 'react-router-dom';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '八仔漫画网',
  url: 'https://www.bazai-comics.com',
  description: '八仔漫画网在线免费阅读全职法师漫画全集，无需付费，无广告干扰，纯净阅读环境。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.bazai-comics.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '八仔漫画网',
  url: 'https://www.bazai-comics.com',
  description: '国内领先的正版漫画在线阅读平台',
  foundingDate: '2018',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+86-400-888-6666',
    contactType: 'customer service',
    email: 'contact@bazai-comics.com',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqList.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

export default function Home() {
  useEffect(() => {
    document.title = '全职法师漫画-在线免费阅读漫画全集-八仔漫画网';
  }, []);

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroBanner />

          <HotRanking />

          <LatestUpdates />

          <CategoryGrid />

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                <div>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
                    <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                      主编力荐 · {featuredComic.title}
                    </h2>
                  </div>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    {featuredComic.description}
                  </p>
                  <div className="flex flex-wrap gap-2 mt-4">
                    {featuredComic.tags.map((tag) => (
                      <span key={tag} className="px-3 py-1 rounded-full text-xs bg-primary-100 text-primary-700 whitespace-nowrap">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="flex items-center gap-4 mt-4 text-sm text-foreground-500">
                    <span>作者：{featuredComic.author}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-star-fill text-accent-500"></i> {featuredComic.rating}分
                    </span>
                    <span>{featuredComic.chapters}话</span>
                  </div>
                  <Link
                    to={`/article/${featuredComic.id}`}
                    className="inline-flex items-center gap-2 mt-5 px-5 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
                  >
                    <i className="ri-book-open-line"></i>
                    开始阅读
                  </Link>
                </div>
                <div className="relative">
                  <img
                    src={featuredComic.cover}
                    alt={`${featuredComic.title} 漫画封面`}
                    title={`${featuredComic.title} - 八仔漫画网`}
                    className="w-full max-w-sm mx-auto rounded-lg"
                  />
                </div>
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                  常见问题
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {faqList.slice(0, 6).map((faq, idx) => (
                  <details key={idx} className="group bg-background-50 rounded-lg border border-background-200/70 p-4 md:p-5">
                    <summary className="flex items-center justify-between cursor-pointer text-sm md:text-base font-medium text-foreground-800">
                      {faq.question}
                      <i className="ri-add-line group-open:hidden text-foreground-400"></i>
                      <i className="ri-subtract-line hidden group-open:block text-foreground-400"></i>
                    </summary>
                    <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </details>
                ))}
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}